import { isServer } from './dom';

let el = null;

if (!isServer) {
  createAlertEl();
}

function createAlertEl() {
  el = document.createElement('p');
  el.setAttribute('role', 'status');
  el.className = 'aria-alert-hidden';
  document.body.appendChild(el);
}

export function readAria(text) {
  el.style.display = 'none';
  el.innerText = text;
  el.style.display = 'block';
}
